// dependencies
import { Map } from "immutable";
import React from "react";
import { connect } from "react-redux";

// components
// actions
import { StateChange } from "../../../../actions/page.actions";

// utils
import Cookies from "../../../../utils/Cookies";

import PropTypes from "../../../../lib/prop-types";

// constants
import Config from "../../Config";

class LetterLabels extends React.Component {
	static propTypes = {
		showLetterToggle: PropTypes.bool,
		searchInput: PropTypes.string,
		userLabelCounts: PropTypes.instanceOf(Map),
		storeLabelSearchingInCookies: PropTypes.bool.isRequired,
		onSearch: PropTypes.func.isRequired,
		changeState: PropTypes.func.isRequired,
		activeLetter: PropTypes.string.isRequired,
		height: PropTypes.number.isRequired,
		letterSearching: PropTypes.oneOf(["first", "last"]),
	};

	static defaultProps = {
		searchInput: "",
		showLetterToggle: true,
		letterSearching: "last",
		userLabelCounts: Map(),
	};

	componentDidMount() {}

	shouldComponentUpdate(nextProps) {
		// don't update if the `userLabelCounts` is the same.

		const activeLetterChanged = nextProps.activeLetter !== this.props.activeLetter;
		const letterSearchToggled = nextProps.letterSearching !== this.props.letterSearching;
		const letterLabelCountsUpdated = nextProps.userLabelCounts.hashCode() !== this.props.userLabelCounts.hashCode();

		if (!letterLabelCountsUpdated && !letterSearchToggled && !activeLetterChanged) {
			return false;
		}

		return true;
	}

	toggleLetterSearch = () => {
		const currentLetter = this.props.letterSearching;
		const nextLetter = currentLetter === "first" ? "last" : "first";
		if (this.props.storeLabelSearchingInCookies) {
			Cookies.set("letterSearching", nextLetter);
		}

		this.props.changeState(["letterSearching"], nextLetter);
		this.props.onSearch({
			query: this.props.searchInput,
			page: 1,
			letter: this.props.activeLetter,
			lastName: nextLetter === "last",
		});
	};

	handleClick = (value) => {
		let letter = value;

		if (this.props.activeLetter === letter) {
			letter = "";
		} else if (letter === undefined) {
			letter = this.props.activeLetter;
		}

		this.props.onSearch({
			query: this.props.searchInput,
			page: 1,
			letter,
			lastName: this.props.letterSearching === "last",
		});
	};

	render() {
		// destructure
		const { userLabelCounts, height, activeLetter, showLetterToggle, letterSearching } = this.props;

		//
		const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ*";
		const letterCount = showLetterToggle ? letters.length + 1 : letters.length;
		const labelHeight = height / letterCount;

		const labels = letters.split("").map((letter) => {
			const count = userLabelCounts.getIn([letter, "count"], 0);
			const displayCount = count > 0 ? (count > 99 ? "99+" : count) : ""; // eslint-disable-line no-nested-ternary

			return (
				<div
					key={letter}
					onClick={() => {
						this.handleClick(letter);
					}}
					className={`label-box${count > 0 ? "has-count" : "has-count"}${
						activeLetter === letter ? "is-active" : ""
					}`}
					style={{
						height: labelHeight,
						lineHeight: `${labelHeight}px`,
					}}
				>
					<div className="label">{letter}</div>
					{count > 0 ? (
						<div style={{ left: Config.labelsWidth + 6 }} className="count">
							{displayCount}
						</div>
					) : (
						""
					)}
				</div>
			);
		});

		const letterToggleButton = (
			<div className="toggle-letter-button-container">
				<div
					onClick={this.toggleLetterSearch}
					style={{
						height: labelHeight,
						lineHeight: `${labelHeight}px`,
					}}
					className="toggle-letter-button"
				>
					{letterSearching === "first" ? "Fi" : "La"}
				</div>
				<div
					style={{
						top: (labelHeight - 32) / 2,
						left: Config.labelsWidth + 5,
					}}
					className="toggle-tooltip"
				>
					{letterSearching === "first" ? (
						<div className="label">
							Sort by <span>Fi</span>rst Name
						</div>
					) : (
						<div className="label">
							Sort by <span>La</span>st Name
						</div>
					)}
				</div>
			</div>
		);

		return (
			<section style={{ width: Config.labelsWidth, height }} className="letter-labels-container">
				{showLetterToggle ? letterToggleButton : ""}
				{labels}
			</section>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	userLabelCounts: state.users.get("userLabelCounts"),
	searchInput: state.page.getIn([ownProps.storeName, "searchInput"]),
	letterSearching: state.page.getIn([ownProps.storeName, "letterSearching"]),
	activeLetter: ownProps.updateURLQuery
		? state.users.getIn(["_currentQuery", "letter"])
		: state.page.getIn([ownProps.storeName, "letter"]),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	changeState: (keyPath, value) => dispatch(StateChange(ownProps.storeName, keyPath, value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LetterLabels);
